import { permission } from '@/mixins/common/permission';
import { mixinSuper } from '@/mixins/common/mixinSuper';
import msValidate from '@/components/validate/MsValidate.vue';
import { filter } from '@/mixins/common/filter';
import { collectionMonitor } from '@/setup/utilities/monitor';
import { showError, showConfirm, showErrorCustom } from '@/commons/globalMessage';
import npsFunction from '@/commons/NPSFunction';
import popupUtil from '@/commons/popupUtil';
import restoreVoucherApi from '@/apis/audit/restoreVoucherAPI.js';
import _ from 'lodash';
import indexedDB from '@/commons/indexedDB';
import { ModuleOfflineWork } from '@/stores/moduleConst';
import baseBrowserTitlePage from '@/views/base/baseBrowserTitlePage';

export default {
  extends: baseBrowserTitlePage,
  name: 'BaseDetail',
  mixins: [filter, mixinSuper, permission],
  components: {
    msValidate,
  },
  data() {
    return {
      /**
       * Mã màn hình hiện tại
       */
      screenCode: '', //module chính của form
      module: null, //mở form ở mode nào: thêm, sửa, nhân bản
      editMode: this.$ms.constant.FormState.Add, //tiêu đề của form
      title: null, //dữ liệu binding
      model: {},
      /**
       * Danh sách các trường dữ liệu gốc của dữ liệu
       */ originFields: [],
      /**
       * biến có cho mặc định focus ko
       */ autoFocus: true,
      /**
       * Đang xử lý với server
       */ loading: false,
      /**
       * dữ liệu cũ
       */ oldDataItem: {},
      entityState: null,
      /**
       * Giữ tạm thời các file dc thông qua khi upload
       */
      fileTemps: [],
      /**
       * Có dùng shortkey không
       */ hasShortKey: true,
      /** Cache lại param khi refresh */
      isCacheParam: false,
      /**
       * Lock command để thực hiện copy xong mới mở command để save
       */
      lockCommandAction: false,
      /**
       * Hiển thị hướng dẫn
       */
      showStep: false,
      /**
       * Là bản ghi phục hồi từ thùng rác
       */
      isRestoreVoucher: false,
      /**
       * Bản ghi gốc (dùng cho phục hồi chứng từ)
       */
      originRecord: {},
    };
  },
  computed: {
    /**
     * Dùng cho form có mode view
     */
    viewing: function () {
      return this.editMode === this.$ms.constant.FormState.View;
    },
    /**
     * Dùng cho mất mạng
     */
    offlineReady() {
      if (!this.$store.state[ModuleOfflineWork]) return false;
      return this.$store.state[ModuleOfflineWork].offlineReady;
    },

    /**
     * Lấy dữ liệu db Option
     * NXCHIEN 06.07.2022
     */
    dbOptions: function () {
      return this.$store?.state?.dbOption?.dbOptions;
    },
    /**
     * Ngày khóa sổ
     * NXCHIEN 21.03.2023
     */
    dBDateClosed: function () {
      return this.$store?.state?.dbOption?.dbOptions?.DBDateClosed;
    },

    /**
     * Ngày bắt đầu dữ liệu
     * NVTUAN1 25.04.2023
     */
    dBStartDate: function () {
      return this.$store?.state?.dbOption?.dbOptions?.DBStartDate;
    },
  },
  watch: {
    loading: function (newVal) {
      if (newVal) {
        this.$ms.commonFn.mask();
      } else {
        this.$ms.commonFn.unmask();
      }
    }
  },
  created() {
    window._xx = this;
  },
  mounted() {
    const me = this;
    window._listDetail = me; // TODO: Trong code không dùng cái này (chỉ dùng để debug)
    me.addHandler();
    me.addObserveControl();
  },
  methods: {
    /**
     * Đẩy dữ liệu lên monitor
     * @param {*} command
     */
    pushTrans(command, isPrintVoucher = false, report) {
      const { pushTrans } = collectionMonitor();
      if (!isPrintVoucher) {
        pushTrans(command, this.getModuleName() || this.screenCode, this.layoutTagDetail || this.screenCode);
      } else {
        var screenName = '';
        var module = '';
        if (report) {
          if (report.report_id) {
            this.screenCode = report.report_id.replace(
              /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
              '',
            ); // Code không để ký tự đặc biệt
          }
          screenName = report.report_name;
          module = this.module;
        }
        pushTrans(command, screenName, module ? `${module}.${this.screenCode}` : this.screenCode);
      }
    },
    /**
     * Khởi tạo observe control
     * NCPHUOC 20/04/2022
     * .ms-validate được thêm vào root khi khai báo rules
     */
    addObserveControl() {
      if (!this._observeControls) {
        this._observeControls = [];
        const $el = this.$el;
        const $controls = $el.querySelectorAll('.ms-validate');
        if ($controls && $controls.length > 0) {
          $controls.forEach(item => {
            if (typeof item.getVueInstance === 'function') {
              this._observeControls.push(item.getVueInstance());
            }
          });
        }
      }
    },

    /**
     * Lấy ra danh sách control có validate
     * dtnga3 (28.07.2022)
     */
    getObserveControl() {
      return this._observeControls;
    },

    /**
     * Xử lý thêm mới
     * @param data
     */
    async add(param) {
      const me = this;
      //kiểm tra phân quyền - tvhien 12.12.2022
      me.checkActionPermissionAlert(me.$ms.constant.Permission.Add);
      const mode = me.$ms.constant.FormState.Add;

      me.entityState = me.$ms.constant.ModelState.Insert;

      /** Lưu chứng từ hiện tại hoặc active để khi hoãn thì back về chứng từ trước đó */
      me.savePrevVoucher(param);
      //lấy dữ liệu
      if (param?.isRestoreVoucher) {
        //Nếu là bản ghi phục hồi thì lấy dữ liệu đc truyền sang
        me.isRestoreVoucher = true;
        me.originRecord = param;
        await me.loadData('Edit', param);
        var data = param.data;
      } else {
        me.isRestoreVoucher = false;
        var data = await me.loadData('New', param);
      }

      // Nếu có trường is_system thì đặt là false
      //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
      if (data && typeof data == 'object' && data.hasOwnProperty('is_system')) {
        data.is_system = false;
      }

      // xử lý dữ liệu trước khi binding (VD: thêm ngày CT, ngày HT...)
      me.beforeBinding(data, mode);

      //Cập nhật dữ liệu vào model
      me.bindData(data);

      // Lập chứng từ từ Hóa đơn xử lý đầu vào
      if (param?.isCreateFromInbot) {
        me.bindDataFromInbot(data, param.dataInbot, param.dataInbotDetail, param?.dataInbotTax);
      }
      //Gán form mode
      me.setFormMode(mode);

      //reset validate
      me.$nextTick(() => {
        me.resetValidate();

        //Cập nhật OldData để track change
        me.setOldDataItem();
        if (me.autoFocus) {
          //focus first control
          setTimeout(function () {
            me.focusFirstControl();
          }, 300);
        }
      });
    },

    /**
     * Bindding dữ liệu khi thêm chứng từ từ Hóa đơn
     */
    bindDataFromInbot(data, dataInbot, dataInbotDetail, dataInbotTax) { },

    /**
     * Lưu chứng từ hiện tại hoặc active để khi hoãn thì back về chứng từ trước đó
     * @author nnnam - 13.9.2022
     */
    savePrevVoucher(param) {
      const me = this;

      me.beforeSavePreVoucher(param);

      let module = me.listModule || me.module;
      if (param && !param.prev_data) {
        const gridData = me.$store.getters[`${module}/items`],
          config = me.$store.getters[`${module}/_config`];

        if (config) {
          const { field } = config;
          let id = me.model[field.key] || param.id;

          if (id) {
            if (gridData?.length) {
              var row = gridData.find(x => x[field.key] === id);
            }

            /** Nếu là chi tiết thì lưu chứng từ hiện tại */
            me.prev_data = row;
          } else {
            let active = me.$store.getters[`${module}/active`];
            if (active) {
              /** Nếu là Master thì lưu chứng từ đang active */
              me.prev_data = active;
            }
          }
        }
      }
    },

    beforeSavePreVoucher(param) { },

    /**
     * focus control nhập liệu đầu tiên
     */
    focusFirstControl() {
      this.$ms.commonFn.focusFirstControlInput(this.$el);
    },

    /**
     * Gán state cho form
     */
    setFormMode(mode) {
      this.editMode = mode;

      //cập nhật tiêu đề cho form
      this.title = this.getFormTitle(mode);
    },

    /**
     * Lấy tiêu đề form
     */
    getFormTitle(mode) {
      const me = this;
      let title = [];

      title.push(me.$ms.commonFn.getEnumResource(mode, 'FormState'));
      title.push(me.getModuleName() || '');

      return title.join(' ');
    },

    /**
     * Lấy key từ các tham số
     */
    getKeyCache(...args) {
      return args.filter(x => x).join('_');
    },

    /**
     * Lấy tên đối tượng của form
     */
    getModuleName() {
      const me = this;
      return me.$tm('i18nCommon.module.' + me.module);
    },

    /**
     * Bind dữ liệu cho form
     */
    bindData(data) {
      const me = this;

      me.bindingDetail(data);

      //master
      me.model = data;
      me.beforeBindData(data);
    },

    bindingDetail(data) {
      const me = this;

      //details
      if (me.detailFields) {
        for (let i = 0; i < me.detailFields.length; i++) {
          let field = me.detailFields[i];
          if (!data[field]) {
            data[field] = [{ append: false, isTemp: true }];
          }
        }
      }
    },
    async beforeBindData(data) { },
    /**
     * Xử lý sửa
     * @param data
     */
    async edit(param) {
      const me = this;
      const mode = me.$ms.constant.FormState.Edit;
      me.entityState = me.$ms.constant.ModelState.Update;

      //nếu sửa có truyền dữ liệu -> binding dữ liệu truyền lên trước trong khi đang chờ load dữ liệu từ server
      if (param && typeof param.data === 'object') {
        me.model = { ...param.data };
      }

      //lấy dữ liệu
      let data = [];
      if (!me.offlineReady) {
        // Nếu có mạng thì call API
        data = await me.loadData('Edit', param);
      } else {
        // Nếu offline thì lấy từ param
        data = param.data;
        data.state = mode;
      }
      if (!data) {
        console.error('Không có dữ liệu');
        return;
      }

      // xử lý dữ liệu trước khi binding
      me.beforeBinding(data, mode);

      //Cập nhật dữ liệu vào model
      me.bindData(data);

      //Gán form mode
      me.setFormMode(mode);

      //reset validate
      me.$nextTick(() => {
        if (me.autoFocus) {
          //focus first control
          setTimeout(function () {
            me.focusFirstControl();
            me.afterEditForm();
          }, 200);
        }
        me.resetValidate();

        //Cập nhật OldData để track change
        me.setOldDataItem();
      });
    },
    afterEditForm() { },
    /**
     * Xử lý view
     * pvduy 27/02/2021
     * @param data
     */
    async view(param) {
      const me = this;
      const mode = me.$ms.constant.FormState.View;

      /** Lưu chứng từ hiện tại hoặc active để khi hoãn thì back về chứng từ trước đó */
      me.savePrevVoucher(param);

      //nếu sửa có truyền dữ liệu -> binding dữ liệu truyền lên trước trong khi đang chờ load dữ liệu từ server
      if (param && typeof param.data === 'object') {
        me.model = { ...param.data };
      }

      //lấy dữ liệu
      let data = [];
      // Nếu mất mạng thì data lấy từ param
      if (me.offlineReady || me.model?.isSaveOffline) {
        data = param.data;
      } else {
        data = await me.loadData('Edit', param);
      }
      // xử lý dữ liệu trước khi binding
      me.beforeBinding(data, mode);

      //Cập nhật dữ liệu vào model
      me.bindData(data);

      //Gán form mode
      me.setFormMode(mode);

      //reset validate
      me.$nextTick(() => {
        if (me.autoFocus) {
          //focus first control
          setTimeout(function () {
            me.focusFirstControl();
          }, 200);
        }
        me.resetValidate();

        //Cập nhật OldData để track change
        me.setOldDataItem();
      });
    },

    /**
     * Nhân bản
     * @param data
     */
    async duplicate(param) {
      const me = this;
      //kiểm tra phân quyền - tvhien 12.12.2022
      me.checkActionPermissionAlert(me.$ms.constant.Permission.Add);
      const mode = me.$ms.constant.FormState.Duplicate;

      /** Lưu chứng từ hiện tại hoặc active để khi hoãn thì back về chứng từ trước đó */
      me.savePrevVoucher(param);

      //nếu sửa có truyền dữ liệu -> binding dữ liệu truyền lên trước trong khi đang chờ load dữ liệu từ server
      if (param && typeof param.data === 'object') {
        me.model = { ...param.data };
      }
      //lấy dữ liệu
      var data = await me.loadData('Duplicate', param);

      // Nếu có trường is_system thì đặt là false
      //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
      if (data && typeof data == 'object' && data.hasOwnProperty('is_system')) {
        data.is_system = false;
      }

      // xử lý dữ liệu trước khi binding
      await me.beforeBinding(data, mode, param);

      //Cập nhật dữ liệu vào model
      me.bindData(data);

      //Gán form mode
      me.setFormMode(mode);

      //reset validate
      me.$nextTick(() => {
        if (me.autoFocus) {
          //focus first control
          setTimeout(function () {
            me.focusFirstControl();
          }, 200);
        }
        me.resetValidate();

        //Cập nhật OldData để track change
        me.setOldDataItem();
        /** Reset lại tham số vì khi nhân bản thì server sẽ trả về id mới */
        me._loadParam = null;
      });
    },

    /**
     * Copy từ chứng từ khác
     * @param data
     */
    async copy(param) {
      const me = this;
      //kiểm tra phân quyền - tvhien 12.12.2022
      me.checkActionPermissionAlert(me.$ms.constant.Permission.Add);
      const mode = me.$ms.constant.FormState.Duplicate;

      /** Lưu chứng từ hiện tại hoặc active để khi hoãn thì back về chứng từ trước đó */
      me.savePrevVoucher(param);

      // Nếu có trường is_system thì đặt là false
      //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
      if (param.data && typeof param.data == 'object' && param.data.hasOwnProperty('is_system')) {
        param.data.is_system = false;
      }

      // xử lý dữ liệu trước khi binding
      me.beforeBinding(param.data, mode);

      //Cập nhật dữ liệu vào model
      me.bindData(param.data);

      //Gán form mode
      me.setFormMode(mode);

      //reset validate
      me.$nextTick(() => {
        if (me.autoFocus) {
          //focus first control
          setTimeout(function () {
            me.focusFirstControl();
          }, 200);
        }
        me.resetValidate();

        //Cập nhật OldData để track change
        me.setOldDataItem();
        /** Reset lại tham số vì khi nhân bản thì server sẽ trả về id mới */
        me._loadParam = null;
      });
    },

    /**
     * Gọi api load dữ liệu
     */
    async loadData(action, param) {
      const me = this;
      let result = {};

      me.loading = true;
      try {
        //xử lý dữ liệu truyền lên để không truyền gọi lên server
        let defaultData = param.data || {};
        let paramRequest = Object.assign({}, param);
        delete paramRequest.data;

        let loadParam = me.getLoadDataParameter(action, paramRequest);
        //Giữ lại để sử dụng
        me._loadParam = loadParam;
        if (me.module) {
          if (!me.isRestoreVoucher) {
            result = await me.$store.dispatch(`${me.module}/get`, loadParam);
          }
          if (!result) {
            result = { ...defaultData };
          }

          //xử lý trước khi render
          me.processLoadData(result, action, param);

          // Xử lý trước khi trả về dữ liệu
          await me.processAfterLoadData(result, action, param);
        }
      } catch (err) {
        console.error(err);
      } finally {
        me.loading = false;
      }

      return result;
    },
    /**
     * Xử lý dữ liệu sau khi load dữ liệu
     * tbngoc 08.10.2023
     */
    async processAfterLoadData(result, action, param) { },
    /**
     * Xử lý dữ liệu client sau khi load từ server về trước khi binding
     */
    processLoadData(data, action, param) {
      const me = this;

      //xử lý dữ liệu mở rộng
      me.originFields = [];
      //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
      if (data.hasOwnProperty('ExtData')) {
        //Danh sách các trường dữ liệu gốc của dữ liệu
        for (let i in data) {
          me.originFields.push(i);
        }

        //map dữ liệu mở rộng
        if (data.ExtData && typeof data.ExtData === 'string') {
          let extData = JSON.parse(data.ExtData);
          if (extData) {
            me.$ms.commonFn.processServerResponseData(extData);
            for (let m in extData) {
              //chỉ map các trường không có trong dữ liệu gốc
              if (me.originFields.indexOf(m) === -1) {
                data[m] = extData[m];
              }
            }
          }
        }
      }

      //xử lý mặc định quickAddText vào trường text
      //Tạm rem đoạn tự động binding vào form khi có quicksearch text do binding sai ở combo chọn nhiều
      //NCPHUOC 11/07/2022
      // if (param && param.quickAddText) {
      //   let fcf = me.$store.state[me.module]._config.field;
      //   if (fcf.name && !data[fcf.name]) {
      //     data[fcf.name] = param.quickAddText;
      //   }
      // }
    },
    /**
     * Lấy tham số load dữ liệu cho form
     */
    getLoadDataParameter(action, param) {
      let result = {
        action: action,
      };

      switch (action) {
        case 'Edit':
        case 'View':
        case 'Duplicate':
          result.id = param.id;
          break;
      }

      this.customVoucherLoadData(result);

      return result;
    },
    /**
     * Hàm thực hiện set lấy thêm reftype để xử lý cho autoID
     * NXCHIEN 27.05.2022
     */
    customVoucherLoadData(result) { },
    /**
     * Hàm thực hiện set giá trị cho oldData mặc định là giá trị ban đầu khi mở form
     * Hàm này được gọi trong hàm mở form showPopup()
     */
    setOldDataItem(model = this.model) {
      const me = this;
      me.$nextTick(() => {
        me.oldDataItem = _.cloneDeep(model);
      });

      if (me.editMode === me.$ms.constant.FormState.Duplicate) {
        me.model.fakeChange = true; // Mode Duplicate thì khi click X sẽ thông báo có thay đổi dữ liệu
      }
    },

    /*
     * Hàm reset lại giá trị
     * pvduy 02/07/2021: phục vụ mục đích khi tích chức năng x trên control mscontrol field
     * nnlam 08/09/2021; sửa lại cho ngắn gọn dễ dùng
     */
    resetData() {
      let me = this;
      //Thực hiện sort lại dữ liệu trong các grid detail của oldDataItem trước khi gán lại vào model
      //TVDAT 03/08/2022
      var detailKeys = Object.keys(me._gridDetails || {});

      detailKeys.forEach(key => {
        //TVDAT 27/07/2022: Chỗ này sort lại dữ liệu trong các grid detail theo sort_order
        //NVTUAN1 28.09.2022: Tạo hàm sortGridDetail để dev override thực hiện sort tùy theo nghiệp vụ từng màn hình
        if (me.oldDataItem[key] && Array.isArray(me.oldDataItem[key])) {
          me.sortGridDetail(me.oldDataItem[key]);
        }
      });

      //Dùng cloneDeep để không bị lỗi date bị trừ 1 ngày khi hoãn
      me.model = _.cloneDeep(me.oldDataItem);
      me.resetValidate();
    },

    /**
     * Thực hiện sort dữ liệu trong grid detail (mặc định theo sort_order)
     * DEV muốn sort theo các trường dữ liệu khác thì override lại hàm này
     * NVTUAN1 03.10.2022
     */
    sortGridDetail(data) {
      const me = this;
      data.sortObject('sort_order');
    },

    /**
     * Xử lý phím tắt
     */
    // shortkeyAction(e) {
    //   let me = this;
    // 	switch (e.srcKey) {
    // 		case 'Save':
    // 			me.save(this.$ms.constant.SaveMode.Save);
    //       break;
    //     case 'SaveAndAdd':
    //       me.save(this.$ms.constant.SaveMode.SaveNew);
    //       break;
    //     case 'Print':
    //       me.print();
    //       break;
    //     default:
    //       break;
    // 	}
    // },

    //in
    print() { },
    /**
     * set dữ liệu cho model
     * Created by LTDAT(25.06.2020)
     */
    setModel(data) {
      const me = this;
      me.model = data;
    },
    /**
     * Hàm validate các control input
     * Hàm này sử dụng component ms-validate
     * để bao ngoài vùng được validate
     * @Chú ý:ref của ms-validate phải là validateObserver
     * Created by LTDAT(18.06.2020)
     */
    validateComponents() {
      const me = this;
      //refs của ms-validate
      // let controls = me._observeControls.filter(x => x.$el.closest('.control-group').style.display !== 'none');
      //let controls = me._observeControls.filter(x => x.$el.closest('.control-group').css('display') == 'none');
      let controls = me._observeControls.filter(
        x =>
          x.$el.offsetWidth ||
          x.$el.offsetHeight ||
          x.$el.getClientRects().length ||
          /** Xử lý validate control khi ẩn */
          (Array.isArray(x?.rules) && x.rules?.some(x => x.hide)),
      );
      if (controls.length > 0) {
        const errors = controls.map(x => {
          if (typeof x.validate === 'function') {
            return x.validate();
          }
          return '';
        });
        return !errors.some(x => x);
      }

      return true;
    },
    /**
     * Hàm dùng để focus vào ô lỗi đầu tiên
     * Created by LTDAT(22.06.2020)
     * NXCHIEN 17.11.2023: sửa focus lỗi - bug 370843
     * */
    focusFirstError(scope) {
      const me = this;
      const $el = scope ?? me.$el;
      const firstErrorEl = $el.querySelector(
        '.ms-editor .error input,.ms-editor .error textarea,.ms-editor .display-error input,.ms-editor .display-error a',
      );
      if (firstErrorEl) {
        setTimeout(() => {
          if (firstErrorEl.tagName === 'INPUT') {
            firstErrorEl.focus();
          } else {
            firstErrorEl.click();
          }
        }, 50);
      }
    },
    /**
     * Cập nhật lại trạng thái validate về ban đầu
     * Created by LTDAT(23.06.2020)
     */
    resetValidate() {
      const me = this;
      if (Array.isArray(me._observeControls)) {
        me._observeControls.forEach(control => {
          if (typeof control.clearValidate === 'function') {
            control.clearValidate();
          }
        });
      }
    },

    /**
     * Hàm xử lý sự kiện lưu form
     */
    save(mode) {
      const me = this;
      me.loading = true;
      //Kiểm tra phân quyền
      try {
        me.checkActionPermissionAlert(
          me.editMode === me.$ms.constant.FormState.Edit
            ? me.$ms.constant.Permission.Edit
            : me.$ms.constant.Permission.Add,
        );
      } catch (error) {
        me.loading = false;
        return;
      }

      if (me.lockCommandAction) {
        setTimeout(() => {
          me.lockCommandAction = false;
        }, 1000);
        me.loading = false;
        console.error('lock command cannot save action');
        return;
      }

      me.beforeSave();
      // setTimeout(function () {
      try {
        // if (!me.validateComponents()) {
        //   nextTick(() => {
        //     me.focusFirstError();
        //   });
        //   me.loading = false;
        //   return;
        // }

        //Thêm hàm tạo action để trường hợp cần custom action thì override lại
        //TVDAT 07/09/2022
        let action = me.createAction();
        let saveParam = me.getSubmitParam(mode);
        me.submitAction(saveParam, action);
      } catch (err) {
        console.error(err);
        me.loading = false;
      }
      // }, window._appConfig.saveTimeout);
    },

    /**
     * Sinh tham số submit lên server
     */
    getSubmitParam(mode) {
      const me = this;

      let saveMode = typeof mode === 'number' ? mode : me.$ms.constant.SaveMode.Save;
      //Nếu edit là update, nếu add hoặc duplicate là insert
      let entity = me.getSaveData(saveMode, me.entityState || me.$ms.constant.ModelState.Insert);

      // truyền thêm refType để xử lý autoID
      let refTypeParam;
      if (entity?.refTypes) {
        refTypeParam = entity.refTypes;
        delete entity.refTypes;
      }

      let saveParam = {
        Mode: saveMode,
        Model: entity,
        ReturnRecord: true,
        Ignores: [],
        refTypes: refTypeParam,
        IsQuickEditVoucher: me.isQuickEditVoucher ? me.isQuickEditVoucher : false,
      };

      me.customSubmitParam(saveParam);
      return saveParam;
    },

    /**
     * Hàm override, dùng để custom param trước khi save
     * NCPHUOC 20/07/2022
     */
    customSubmitParam(saveParam) { },

    /**
     * Gọi validate client và submit dữ liệu lên server
     */
    submitAction(saveParam, action) {
      const me = this;

      let validateResult = me.validateBusiness(saveParam, action);

      // dtnga3 (08.07.2022) check thêm TH show form cảnh báo luôn ở hàm validateBusiness mà k muốn show cảnh báo theo base
      if (!validateResult) {
        me.loading = false;
        return;
      }
      if (Object.keys(validateResult) && Object.keys(validateResult).length > 0) {
        //nếu validate thất bị thì ẩn mask loading để hiển thị thông báo lỗi
        me.loading = false;
        showError(validateResult.message, validateResult.title);
        return;
      }

      me.submit(saveParam, action);
    },

    /**
     * Xử lý cất dữ liệu
     */
    submit(param, action) {
      const me = this;
      //show mask
      me.loading = true;

      // Bổ sung thêm vào param những bản ghi ảnh hưởng
      // tbngoc: 05.07.2022 Bổ sung thêm phần gọi cập nhật ngừng theo dõi, theo dõi
      let ids, value;
      if (me.options && typeof me.options.getIdsChange === 'function') {
        const res = me.options.getIdsChange(me.oldDataItem, param, me.editMode);
        param.ids = res.ids;
        ids = res.ids;
        value = res.value;
      }

      me.$store
        .dispatch([me.module, action].join('/'), param)
        .then(result => {
          // try {
          //   me.insertAuditingLog(result, param, action);
          // } catch (error) {
          //   console.error(error);
          // }
          if (me.model?.ref_type == me.$ms.constant.RefType.BUVoucherListPlanned || me.model?.ref_type == me.$ms.constant.RefType.BUVoucherListNotPlanned) {
            me.loading = true;
          }

          me.saveSuccess(result, param, action);
          // Cập nhật bản ghi ảnh hưởng
          let payload = { data: ids, value };
          me.$store.dispatch(`${me.module}/updateItemQuickFollow`, payload);
          // Cập nhật ảnh hưởng trên bản ghi cha
          if (me.options && me.options.updateParentNode && typeof me.options.updateParentNode === 'function') {
            const res = me.options.updateParentNode(result);
          }
        })
        .catch(ex => {
          if (param?.Model?.isSaveOffline) {
            // Nếu là làm việc offline => cất vào storeage để lấy dữ liệu
            me.setIndexDbDataOffline(param.Model);
          }
          me.saveError(ex, param, action);
        })
        .finally(() => {
          me.loading = false;
        });
    },

    /**
     * Set cache indexDb cho dữ liệu làm việc offline
     * @param {} data: dữ liệu offline lưu cache
     */
    async setIndexDbDataOffline(data) {
      const indexDb = new indexedDB();
      const key = 'cache_dataOffline';
      // Lấy dữ liệu hiện tại đã cache offline nếu có
      let dataOfflineCache = await indexDb.get(key);
      if (dataOfflineCache && Object.keys(dataOfflineCache).length > 0) {
        // Nếu có dữ liệu cache thì cộng cộp cache với dữ liệu đang lưu
        dataOfflineCache = dataOfflineCache.filter(t => t.ref_type == data.ref_type && t.ref_id != data.ref_id);
        dataOfflineCache.push(data);
      } else {
        dataOfflineCache = [data];
      }
      indexDb.set(key, dataOfflineCache);
    },

    /**
     * Xử lý khi cất thành công
     */
    async saveSuccess(result, saveParam, action) {
      let me = this;
      await me.reLoadSummary();
      //Nếu là thêm hoặc sửa thì check để hiển thị khảo sát NPS dqvinh 10.2.2023
      if (saveParam.Mode == me.$ms.constant.ModelState.Update || saveParam.Mode == me.$ms.constant.ModelState.Insert) {
        if (me.isRestoreVoucher) {
          //Nếu là bản ghi phục hồi
          me.originRecord.data.origin_record.delete_date = 0;
          let paramRecycleBin = {
            Models: [me.originRecord.data.origin_record],
            Ignores: [],
          };
          await restoreVoucherApi.delete(paramRecycleBin);
        }
        try {
          await npsFunction.checkSurvey();
        } catch { }
      }
    },

    /**
     * load lại tổng tiền ngoài danh sách
     * NXCHIEN 19.12.2022
     */
    async reLoadSummary() {
      let me = this;
      if (me.$store.state[me.module].payload) {
        await me.$store.dispatch(`${me.module}/loadSummary`, me.$store.state[me.module].payload);
      }
    },

    /**
     * Xử lý khi cất lỗi
     * DVMINH 25/04/2023 Process value thông báo không để thực thi XSS
     * */
    saveError(error, param, action) {
      const me = this,
        errorData = error?.response?.data;

      if (errorData) {
        switch (errorData.Error) {
          case 'VALIDATE':
            me.submitErrorValidate(errorData.Data, param, action);
            break;
          case 'DUPLICATE_FINANCIAL':
            let data = errorData.Data.Data;
            showConfirm(
              `Báo cáo tài chính - kỳ <span>${me.$ms.commonFn.processXssValue(
                data.period_name,
              )}</span> - chương ${me.$ms.commonFn.processXssValue(
                data.budget_chapter_code,
              )} đã được nhập. Bạn có muốn xem báo cáo không?`,
              'Báo cáo đã được lập',
              410,
            ).then(async answer => {
              if (answer) {
                setTimeout(() => {
                  me.hide();
                }, 300);

                popupUtil.show('cRERepListDetail', {
                  mode: me.$ms.constant.FormState.View,
                  id: data.cre_rep_list_id,
                  data: data,
                });
              }
            });
            break;
          case 'VALIDATE_DICTIONARY':
            showError(errorData.Message, me.$tm('i18nBaseForm.Message.InValidUnFollow'));
            break;
          default:
            break;
        }
      } else {
        showError(error?.message);
      }
    },

    /**
     * Xử lý khi cất lỗi
     * nthien4 05.07.2022: Thêm case cho trường hợp phát sinh dữ liệu
     * */
    async submitErrorValidate(er, param, action) {
      const me = this;
      let autoCode = null;
      if (!er.Message && er.Code) {
        er.Message = me.getSubmitValidateError(er.Code, er.Data);
      }
      if (me.isRestoreVoucher && er.Code == me.$ms.constant.ValidateCode.Duplicate) {
        er.Type = me.$ms.constant.ValidateResultType.Warning; // Gán lại Type để show form confirm
        // Xử lý mã tự tăng khi trùng
        if (param?.refTypes) {
          autoCode = await me.$store.dispatch(`${me.module}/getAutoID`, {
            param: JSON.stringify(param.refTypes),
            keys: JSON.stringify(er?.Data),
          });
        }
      }
      switch (er.Type) {
        case me.$ms.constant.ValidateResultType.Warning:
          showConfirm(er.Message).then(answer => {
            if (answer) {
              if (me.isRestoreVoucher) {
                Object.entries(autoCode).forEach(([key, value]) => {
                  if (param?.Model) {
                    param.Model[key] = value;
                  }
                });
              } else {
                param.Ignores = param.Ignores || [];
                param.Ignores.push(er.Code);
              }

              me.submit(param, action);
            }
          });
          break;
        case me.$ms.constant.ValidateResultType.Generation:
          let title = action == 'insert' ? 'Thêm ' : 'Sửa ';
          title += me.$tm('i18nCommon.module.' + me.module);
          showErrorCustom(er.Message, title, 2).then(answer => {
            if (answer) {
              // Nếu chọn đồng ý thì thực hiện chuyển nguồn không xóa
              // Lấy các trường config
              let fields = me.$store.state[me.module]._config.field;

              // Xử lý param truyền lên
              let saveParam = {
                ToData: er.Data.Data.Model,
                FromData: er.Data.DataOld,
                State: action == 'insert' ? 0 : 1,
              };
              me.handleGeneration(saveParam);
            }
          });
          break;
        default:
          me.showSubmitErrorValidate(er, param, action);
          break;
      }
    },

    /**
     * Hàm xử lý chuyển dữ liệu
     * bnanh 08.07.2022
     * nthien4 Thêm API để các hàm dùng base
     */
    async handleGeneration(param) {
      const me = this;
      let result = await me.$store.dispatch(`${me.module}/updateTranferData`, param);
      if (result) {
        me.handleAfterTransferData(param);
        me.$toast.success(me.$t('i18nBaseForm.Message.SaveSuccess'));
        me.hide();
      }
    },
    /**
     * Focus vào dòng mới thêm
     * tbngoc 11.07.2022
     *
     */
    handleAfterTransferData(param) {
      let me = this;

      if (me.options && typeof me.options.submit === 'function') {
        me.options.submit(param.ToData);
      }

      // Xử lý cập nhật bản ghi được chọn
      if (me.options && typeof me.options.submitDetail === 'function') {
        me.options.submitDetail({ Model: param.ToData }, me.$store.state[me.module]._config.field.key);
      }
    },
    /**
     * Hàm show thông báo lỗi
     * HQMINH 27.06.2022
     */
    showSubmitErrorValidate(er, param, action) {
      const me = this;
      //nếu là validate trùng thì show cảnh báo riêng có button Đóng. Ngược lại vẫn chạy như luồng cũ
      switch (er.Code) {
        case me.$tm('i18nEnum.ValidateCode.Duplicate'):
          showErrorCustom(er.Message, this.$tm('i18nBaseForm.Message.ValidateInvalidTitle'), 4);
          break;
        case 'StartWithOther':
          showError(er.Message, this.$tm('i18nBaseForm.Message.ValidateInvalidAccountTitle'));
          break;
        case 'ErrorParentId':
          showError(this.$tm('i18nBaseForm.Message.ValidateErrorParentId').format(er.Data?.Parent?.Title, er.Data?.Parent?.Code, er.Data?.Child?.Title, er.Data?.Child?.Code), 'Sửa không thành công');
          break;
        default:
          showError(er.Message, this.$tm('i18nBaseForm.Message.ValidateInvalidTitle'));
          break;
      }
    },

    /**
     * Lấy nội dung thông báo theo mã validate
     * NCPHUOC 01/06/2022: sửa thông báo theo res trả về mảng thông tin duplicate
     * nthien4 05.07.2022: Thêm case cho trường hợp phát sinh dữ liệu
     */
    getSubmitValidateError(validateCode, errorData) {
      const me = this;
      let msg = '';
      if (me.isRestoreVoucher) {
        msg = me.$tm('i18nBaseForm.Validate.DuplicateRestore');
      } else {
        msg = me.$tm('i18nBaseForm.Validate.' + validateCode);
      }
      switch (validateCode) {
        case 'Duplicate':
        case 'DuplicateTaxCode':
          if (Array.isArray(errorData)) {
            const errorLength = errorData.length;
            const contentMsg = errorData.reduce((pre, cur, i) => {
              let { FieldDisplay, FieldName, FieldValue } = cur;
              if (FieldName.trim() == 'ref_no' && !FieldDisplay.trim()) {
                FieldDisplay = 'Số chứng từ';
              }
              pre += `${me.$ms.commonFn.processXssValue(
                FieldDisplay,
              )} <span class="bold" style="color: #0eac13">${me.$ms.commonFn.processXssValue(FieldValue)}</span>`;
              if (i < errorLength - 1) {
                pre += ', ';
              }
              return pre;
            }, '');
            msg = msg.format(contentMsg);
          }

          break;
        case 'Required':
          /**
          Nhập thiếu thông tin Bán hàng: số, ngày. Chi tiết bán hàng: dòng 1: mã, số lượng. Phiếu xuất kho: số hóa đơn, ngày hóa đơn.
          Chưa kiểm tra Xss với errorData mang sang trong case này.
           */
          let sb = [];
          let item;
          let fields = [];
          for (let i in errorData) {
            let group = errorData[i];
            let name = me.getRequiredName(i);
            sb.push(name, ': ');

            if (group.length === 1 && group[0].Index === -1) {
              item = group[0];
              //master
              fields = [];
              for (let k = 0; k < item.Fields.length; k++) {
                fields.push(me.getRequiredFieldName(i, item.Fields[k]));
              }
              sb.push(fields.join(', '), '. '); //newline
            } else {
              //detail
              for (let j = 0; j < group.length; j++) {
                let item = group[j];

                if (j > 0) {
                  sb.push(';');
                }

                let fields = [];
                for (let k = 0; k < item.Fields.length; k++) {
                  fields.push(me.getRequiredFieldName(i, item.Fields[k]));
                }
              }

              sb.push('. '); //newline
            }

            msg = msg.format(sb.join(''));
          }
          break;
        case 'Arise':
          let moduleName = me.$tm('i18nCommon.module.' + me.module);
          let childName = errorData.FieldName;
          let parentName = errorData.Data.Model.parent_name;
          msg = msg.format(
            moduleName,
            me.$ms.commonFn.processXssValue(childName),
            me.$ms.commonFn.processXssValue(parentName),
          );
          break;
        case 'AccountNotInDI':
          if (errorData && Array.isArray(errorData) && errorData.length > 0) {
            msg = `Tài khoản <span class="color-green">${me.$ms.commonFn.processXssValue(
              errorData.toString(),
            )}</span> không nằm trong hệ thống tài khoản.`;
          } else {
            msg = '';
          }
          break;
        case 'FixedAssetIncremented':
          if (errorData && Array.isArray(errorData) && errorData.length > 0) {
            let fixedAssetCodes = errorData.map(x => x.fixed_asset_code);
            fixedAssetCodes = this.$ms.commonFn.distinct(fixedAssetCodes);
            let fixedAssetCodesStr = fixedAssetCodes.join(', ');
            msg = `Tài sản <span class="color-green">${me.$ms.commonFn.processXssValue(
              fixedAssetCodesStr,
            )}</span> đã được ghi tăng. Vui lòng kiểm tra lại`;
          } else {
            msg = '';
          }
          break;
      }

      return msg;
    },

    /**
     * Chỗ này form sẽ cấu hình để map từ tên thuộc tính binding detail ra text hiển thị
     * Dùng resource
     * @param {*} group
     * @returns
     */
    getRequiredName(group) {
      return this.$tm(['i18nTable', group].join('.'));
    },

    /**
     * Lấy tên trường nhập thiếu thông tin
     * @param {*} type : Dữ liệu gì
     * @param {*} name : Tên trường dữ liệu
     */
    getRequiredFieldName(type, name) {
      return this.$tm(['i18nColumn', type, name].join('.'));
    },

    /**
     * Lấy dữ liệu cất
     * */
    getSaveData(mode, action) {
      let me = this,
        data = null,
        descriptionLog = null;

      //master
      if (typeof me.model.getData === 'function') {
        data = { ...me.model.getData() };
      } else {
        data = { ...me.model };
      }

      //pvduy 08/03/2021 khi sửa sẽ truyền oldData để xử lý - ghi nhật ký truy cập, cập nhật cây....
      if (mode === me.$ms.constant.FormState.Edit) {
        data.OldData = me.oldDataItem;
      }

      return data;
    },

    /**
     * Lấy dữ liệu chi tiết để cất
     */
    getDetailSaveData(key, detailds) {
      let me = this,
        result = [];

      if (Array.isArray(detailds)) {
        for (let i = 0; i < detailds.length; i++) {
          let item = detailds[i];
          if (item.state) {
            result.push(item);
          }
        }
      }

      return result;
    },

    /**
     * Validate lỗi nghiệp vụ
     * CreatedBy: PDKIEN 25/07/2019
     */
    validateBusiness(saveParam, action) {
      return {};
      //return this.businessErrorList.length == 0;
    },

    //Kiểm tra form đã bị thay đổi hay chưa
    //Created by LTDAT(18.06.2020)
    checkChanges() {
      const me = this;
      return me.$ms.commonFn.checkDiff(me.model, me.oldDataItem);
    },

    /**
     * Xử lý sự kiện widget của grid
     */
    gridWidgetEvent(grid, widgetData, e) {
      const me = this;
      switch (widgetData.command) {
        case 'Delete':
          me.removeDetail(grid, widgetData.dataRow);
          break;
      }
    },

    /**
     * Xóa bản ghi chi tiết
     */
    removeDetail(grid, record) {
      const me = this;

      if (record.state === me.$ms.constant.ModelState.Insert) {
        me.model[grid.detailField].remove(record);
      } else {
        record.state = me.$ms.constant.ModelState.Delete;

        grid.removeItem(record);
      }
    },

    /**
     * Thêm bản ghi chi tiết
     */
    addDetail(grid, data = {}) {
      const me = this;

      if (!me.model[grid.detailField]) {
        me.model[grid.detailField] = [];
      }

      data.state = me.$ms.constant.ModelState.Insert;
      me.model[grid.detailField].push(data);
      me.$nextTick(() => {
        grid.startEditLastRow();
      });
    },

    /**
     * Khai báo handler
     * */
    addHandler() {
      const me = this;
    },
    /**
     * Xóa handler đã khai báo trong hàm addHandler
     * */
    removeHandler() {
      const me = this;
    },

    /**
     * Custom dữ liệu thêm mới trên grid
     */
    gridCustomAddNewData(grid, data) { },

    /**
     * Custom lại sự kiện khi thao tác trên grid
     */
    gridRowActionClick(grid, command, record, event) {
      const me = this;
      switch (command) {
        case me.$ms.constant.Command.Delete:
          me.removeDetail(grid, record);
          break;
      }
      this.pushTrans(command);
    },

    /**
     * Khởi tạo dữ liệu khi thêm mới dòng ch itiết
     * @param defaultData
     */
    initNewDetail(defaultData) {
      return defaultData;
    },

    /**
     * Lấy cấu hình cột của grid detail
     * */
    getGridDetailColumnConfig() {
      return this.columnDetail;
    },
    /*
     * pvduy 05/04/2021: thêm hàm xóa trong base detail để có thể xóa trên form chi tiết.
     */
    async delete(record) {
      const me = this;

      //Kiểm tra phân quyền
      me.checkActionPermissionAlert(me.$ms.constant.Permission.Delete);

      let configMessage = await me.getDeleteConfirmMessage(record);
      let answer = await showConfirm(configMessage);
      if (answer === true) {
        let temp = {};
        for (let i in record) {
          switch (i) {
            case 'parentNode':
            case 'isHide':
            case 'isSelected':
            case 'level':
            case '__vKeyValue':
            case '_isSelectedMultiple':
            case 'expanded':
              //bỏ qua 1 só trường
              break;
            default:
              temp[i] = record[i];
              break;
          }
        }
        let paramModel = me.getParamDeleteDetail([temp]);
        let param = {
          Models: paramModel ? paramModel : [temp],
          Ignores: [],
        };
        try {
          let result;
          if (!me.offlineReady) {
            // Nếu có mạng thì call API xóa
            result = await me.$store.dispatch(`${me.module}/delete`, param);
          } else {
            // Nếu mất mạng thì xóa tại indexDB
            const indexDb = new indexedDB();
            let queueData = await indexDb.get('cache_dataOffline');
            if (queueData && Object.keys(queueData).length > 0) {
              let dataAfterDelete = queueData.filter(
                x => x.ref_type != record.ref_type || (x.ref_type == record.ref_type && x.ref_id != record.ref_id),
              );
              indexDb.set('cache_dataOffline', dataAfterDelete ?? []);
            }
          }
          me.deleteSuccess(record, result);
        } catch (ex) {
          me.deleteError(record, ex);
        }
      }
    },

    /**
     * Xử lý sau khi xóa
     */
    deleteError(record, error) {
      //TODO
    },
    /**
     * Xử lý sau khi xóa
     */
    deleteSuccess(record, result) {
      const me = this;

      me.$toast.success(this.$tm('i18nBaseForm.Message.DeleteSuccess'));
    },
    /**
     * Lấy câu thông báo khi xóa
     * Modified TPNAM 10.02.2025 - escape các ký tự đặc biệt chống tấn công XSS
     */
    async getDeleteConfirmMessage(records) {
      const me = this;

      let moduleName = (me.getModuleName() || '').toLowerCase();
      let targetName = '';
      var mes = '';

      if (records && Array.isArray(records) && records.length > 1) {
        mes = this.$tm('i18nBaseForm.Message.ConfirmDeleteMutiTitle').format(_.escape(moduleName));
      } else {
        targetName =
          records[me.$store.state[me.module]._config.field.name] ||
          records[me.$store.state[me.module]._config.field.code];
        mes = this.$tm('i18nBaseForm.Message.ConfirmDelete').format(_.escape(moduleName), _.escape(targetName));
      }

      return {
        title: this.$tm('i18nBaseForm.Message.ConfirmDeleteTitle').format(_.escape(moduleName)),
        message: mes,
      };
    },

    /**
     * Thêm filter ngừng theo dõi
     */
    addFilterInactive(payload) {
      const me = this;
      if (me.entityState === me.$ms.constant.ModelState.Insert) {
        if (!payload.filter) {
          payload.filter = [];
        }

        let map = null;
        for (let i = 0; i < payload.filter.length; i++) {
          let item = payload.filter[i];
          if (item.property === 'Inactive') {
            map = item;
          }
        }

        if (!map) {
          payload.filter.push({
            property: 'Inactive',
            value: false,
            operator: '=',
          });
        }

        if (payload.filter.length == 0) {
          delete payload.filter;
        }
      }
    },

    /**
     * Thực hiện các công việc trước khi save
     */
    beforeSave() {
      const me = this;

      // if (me.$refs[me.refGrid]) {
      //   me.$refs[me.refGrid].endEditor()
      // }
    },
    /**
     * sự kiện ấn vào các action trên form
     */
    buttonClick(command, e) { },

    /**
     * Custom tham số payload trước khi call api
     */
    customPayload(payload) {
      return payload;
    },
    /**
     * Thêm hàm custom lại param với TH có cảnh báo
     */
    async customParamIgnores(param, data) { },

    /**
     * tham số trước khi mở form
     * @param {*} data
     * @param {*} mode
     * NXCHIEN 29.04.2022
     */
    beforeBinding(data, mode, param) { },
    /**
     * Hàm tạo action
     * TVDAT 07/09/2022
     */
    createAction() {
      let me = this;
      return me.editMode === me.$ms.constant.FormState.Edit || me.editMode === me.$ms.constant.FormState.View
        ? 'update'
        : 'insert';
    },

    /**
     * Hướng dẫn
     */
    guide(e, disable) {
      if (!disable) {
        this.showStep = true;
      }
    },

    /**
     * Link help
     */
    linkHelp(code, type) {
      type = type || 'mimosa';
      return window._helpLink[type] + window._misaHelp[code];
    },
    /**
     * Hàm custom tham số khi xóa trong detail
     * TPNAM 28.02.2024
     */
    getParamDeleteDetail(tempArr) {},
  },
  /**
   * Trước khi destroy form
   */
  beforeUnmount() {
    let me = this;

    //xóa tham chiếu để tránh leak
    delete me.param;
    me.removeHandler();
  },
};
